//@flow
///* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import window from '../../../util/window';


// plotty is a library for helping plot 2D data and provide color scaling functionality.
//Put your array data in it and receive a fresh image.

import SmartMap from './smart-map';
import initColorscales from './colorscales';
type Area = [number, number];

type Paint = {
    "raster-colorscale": Object | string;
    "raster-domain-max": number;
    "raster-domain-min": number;
    "clamp-high-value": number;
    "clamp-low-value": number;
    "lerc-clamp-high": boolean;
    "lerc-clamp-low": boolean;
    "lerc-include": Area[];
    "lerc-exclude": Area[];
};

const colorscaleLength = 4096;
const colorscaleHeight = 1;

const isNumber = function (value) {
    return value === 0 || Number(value);
};

/** ç¬¬äºççº¹ççæå¨
 * å°includeåclampä½¿ç¨çº¹çå®ç°ï¼åå°gpuæ§è½æ¶è
 * @author James Zhang
 */
class RenderRaster2 {
    static bind(context) {
        if (context !== RenderRaster2.context) {
            RenderRaster2.cache = new SmartMap();
        }
        RenderRaster2.context = context;
        return RenderRaster2;
    }
    static renderGradientInterval(gradient, color, pos) {
        gradient.addColorStop(pos, color);
    }
    static renderGradientExponential(gradient, color, pos) {
        gradient.addColorStop(pos, color);
    }


    /**
     * å½value<minæ¶ï¼è¿åmin
     * å½value>maxæ¶ï¼è¿åmax
     * å½min<=value<maxæ¶ï¼è¿åvalue
     *
     * @author å¼ åè¯
     * @static
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @returns
     * @memberof RenderRaster2
     */
    static calmp(value: number, min: number, max: number){
        if(value < min){
            return min;
        }
        if(max < value){
            return max;
        }
        return value;
    }

    /** é»è®¤
     * ä½¿ç¨åå°æ°å¯¹é½
     * çº¹çåè¾¨çcolorscaleLengthå¤§çº¦ä¸º4096
     * å®éé«ç²¾åº¦æ°æ®æ å°å°çº¹çä¸ï¼å¦æå¼åå¥½è½å¨ä¸¤ä¸ªåç´ ç¹ä¹é´æ¶ï¼æ æ³é¢æè¿ä¸¤ä¸ªåç´ çé¢è²ï¼ä¼åºç°é¢è²éè¯¯
     * å°æææ°å¼é½æ å°å°colorscaleLengthè¿äºæéçæ°å¼ä¸­ï¼éä½äºç²¾åº¦ï¼ä½æ¯ç¡®å®äºæ¯ä¸ªå¼æ å°çé¢è²
     * @author James Zhang
     */
    static getCalc(paint: Paint){
        return RenderRaster2.getCalcAligin(paint);
    }


    /** è®¡ç®ç²¾ç¡®ä½ç½®
     * @author James Zhang
     */
    static getCalcAccurate(paint: Paint){
        return (pos: number) => {
            const result = (pos - paint["clamp-low-value"]) / (paint["clamp-high-value"] - paint["clamp-low-value"]);
            if(result < 0 || 1 < result){
                console.error(new Error(`å¯è½ææ¸²æéè¯¯ï¼${pos} è¶åºäº [${paint["raster-domain-min"]}, ${paint["raster-domain-max"]}] çèå´ï¼å·²ä½¿ç¨å¼åç«¯ç¹å¼ä»£æ¿ï¼è¯·ä¼ å¥æ­£ç¡®ç raster-domain-min å raster-domain-max`));
                return RenderRaster2.calmp(result,0,1);
            }
            return result;
        };
    }

    /** åèäºå¥ */
    static getCalcRound(paint: Paint){
        const calc = RenderRaster2.getCalcAccurate(paint);
        /** è®¡ç®ä½ç½®ç¾åæ¯ï¼å ä¸ºincludeæ¯å·¦é­å³å¼ï¼èçº¹ççç²¾åº¦æéï¼æä»¥è¦æææçå¼æç²¾åº¦åä¸åæ´ */
        return (pos: number) => {
            const result = Math.round(calc(pos) * colorscaleLength) / colorscaleLength;
            return result;
        };
    }

    /** åå°æ°å¯¹é½ */
    static getCalcAligin(paint: Paint){
        const calc = RenderRaster2.getCalcAccurate(paint);
        /** è®¡ç®ä½ç½®ç¾åæ¯ï¼å ä¸ºincludeæ¯å·¦é­å³å¼ï¼èçº¹ççç²¾åº¦æéï¼æä»¥è¦æææçå¼æç²¾åº¦åä¸åæ´ */
        return (pos: number) => {
            const result = Math.floor(calc(pos) * colorscaleLength) / colorscaleLength;
            return result;
        };
    }

    /** åå¤§æ°å¯¹é½
     * @author James Zhang
     */
    static getCalcMore(paint: Paint){
        const calc = RenderRaster2.getCalcAccurate(paint);
        /** è®¡ç®ä½ç½®ç¾åæ¯ï¼å ä¸ºincludeæ¯å·¦é­å³å¼ï¼èçº¹ççç²¾åº¦æéï¼æä»¥è¦æææçå¼æç²¾åº¦åä¸åæ´ */
        return (pos: number) => {
            const result = Math.ceil(calc(pos) * colorscaleLength)/colorscaleLength;
            return result;
        };
    }

    static colorscale2Texture(context, colorscale, paint: Paint) {
        // åä¸ç¹é¢å¤ç
        // ä¸ºäºç§é¡¾éè²è¡¨ä¸ä¸ä¸éåº¦ä¹é´çå¼çé¢è²
        paint["clamp-high-value"] = paint["clamp-high-value"] + RenderRaster2.colorscaleEageValue;
        paint["clamp-low-value"] = paint["clamp-low-value"] - RenderRaster2.colorscaleEageValue;
        // éæ°æåºï¼é¿åæ¸åè²æ¸²æå¼å¸¸
        // TODO å¶å®å¨includeæäº¤éçæåµä¸è¿æ¯ä¼æå¼å¸¸
        paint["lerc-include"] = paint["lerc-include"].sort((item1,item2)=>item1[0]-item2[0]);
        paint["lerc-exclude"] = paint["lerc-exclude"].sort((item1,item2)=>item1[0]-item2[0]);
        colorscale.stops.sort((item1,item2)=>item1[0]-item2[0]);
        RenderRaster2.checkAccuracy(colorscale,paint);
        const canvas = RenderRaster2.colorscale2canvas(colorscale, paint);
        const texture = RenderRaster2.canvas2texture(context, canvas);
        return texture;
    }

    /** æ£æ¥æ°æ®ç²¾åº¦æ¯å¦è¶³å¤
     * ç²¾åº¦ä¸å¤æ¶ï¼å¨æ¥å¿ä¸­è®°å½éè¯¯
     * @author James Zhang
     */
    static checkAccuracy(colorscale, paint: Paint){
        const include = paint["lerc-include"];
        if(include){
            for(let i=0;i < include.length;i++){
                RenderRaster2.checkAccuracyFor2Number(include[i][0],include[i][1], paint);
                if(i < include.length - 1){
                    RenderRaster2.checkAccuracyFor2Number(include[i][1], include[i+1][0], paint);
                }
            }
        }
        const exclude = paint["lerc-exclude"];
        if(include){
            for(let i=0;i < exclude.length;i++){
                RenderRaster2.checkAccuracyFor2Number(exclude[i][0],exclude[i][1], paint);
                if(i < exclude.length - 1){
                    RenderRaster2.checkAccuracyFor2Number(exclude[i][1], exclude[i+1][0], paint);
                }
            }
        }
        
        if(colorscale && colorscale.stops){
            const stops = colorscale.stops;
            for(let i=0;i < stops.length;i++){
                if(i < stops.length - 1){
                    RenderRaster2.checkAccuracyFor2Number(stops[i][0], stops[i+1][0], paint);
                }
            }
        }
    }

    /** æ£æ¥ä¸¤ä¸ªæ°ä¹é´çå·®å¼æ¯å¦è¿å°ï¼è¶è¿ç²¾åº¦éå¶
     * å¦æè¶è¿ï¼è®°å½éè¯¯
     * @author James Zhang
     */
    static checkAccuracyFor2Number(number1: number,number2: number, paint: Paint){
        const calcAligin = RenderRaster2.getCalcAligin(paint);
        if(number1 !== number2 && (Math.abs(calcAligin(number1)*colorscaleLength - calcAligin(number2)*colorscaleLength) < 1)){
            console.warn(new Error(`å¯è½ææ¸²æéè¯¯ï¼${number1}ä¸${number2}çå·®è·å¤ªå°`));
        }
    }

    static colorscale2canvas(colorscale, paint: Paint) {
        
        let canvas;
        if (Object.prototype.toString.call(colorscale) === "[object Object]") {
            canvas =  RenderRaster2.objectScale2canvas(colorscale, paint);
        } else if (Object.prototype.toString.call(colorscale) === "[object Uint8Array]") {
            canvas = RenderRaster2.typedArray2canvas(colorscale);
        } else {
            throw new Error("Color scale not defined.");
        }

        //åå¤mask
        const canvasMask = window.document.createElement("canvas");
        canvasMask.width = colorscaleLength;
        canvasMask.height = 1;
        const ctxMask = canvasMask.getContext("2d");

        ctxMask.save();
        ctxMask.globalCompositeOperation = "source-over";
        for(let gradient of RenderRaster2.getIncludeMaskBand(canvasMask, colorscale, paint)){
            ctxMask.fillStyle = gradient;
            ctxMask.fillRect(0, 0, colorscaleLength, 1);
        }
        ctxMask.restore();

        ctxMask.save();
        ctxMask.globalCompositeOperation = "destination-out";
        for(let gradient of RenderRaster2.getExcludeMaskBand(canvasMask, colorscale, paint)){
            ctxMask.fillStyle = gradient;
            ctxMask.fillRect(0, 0, colorscaleLength, 1);
        }
        ctxMask.restore();

        ctxMask.save();
        ctxMask.globalCompositeOperation = "source-in";
        for(let gradient of RenderRaster2.getClampMaskBand(canvasMask, colorscale, paint)){
            ctxMask.fillStyle = gradient;
            ctxMask.fillRect(0, 0, colorscaleLength, 1);
        }
        ctxMask.restore();

        // å å mask
        const ctx = canvas.getContext("2d");
        ctx.save();
        ctx.globalCompositeOperation = "destination-in";
        ctx.drawImage(canvasMask,0,0);
        ctx.restore();
        // let container = window.document.getElementById("color-stop");
        // if(!container){
        //     console.log(canvas);
        //     // window.document.body.removeChild(oldNode);
        //     container = window.document.createElement("div");
        //     container.id = "color-stop";
        //     container.style.position="absolute";
        //     container.style.left = "200px";
        //     container.style.width = "100%";
        //     container.style.bottom = "0";
        //     container.style.overflow = "scroll";
        //     container.style.backgroundColor = "black";
        //     // container.style.display = "none";
        //     window.document.body.append(container);
        // }
        // canvas.style.height = colorscaleHeight+"px";
        // canvasMask.style.height = colorscaleHeight+"px";
        // container.append(canvas);
        // container.append(canvasMask);
        return canvas;
    }

    /** rgbaï¼255,255,255,1ï¼è¡¨ç¤ºä¿ç
     * @author James Zhang
     */
    static getClampMaskBand(canvas, colorscale, paint: Paint){
        const ctx = canvas.getContext("2d");
        const calc = RenderRaster2.getCalc(paint);
        const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(paint["clamp-low-value"]));

        if(paint["lerc-clamp-low"]){
            RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(paint["clamp-low-value"]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(paint["clamp-low-value"] + RenderRaster2.colorscaleEageValue));
        }else{
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-low-value"]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-low-value"] + RenderRaster2.colorscaleEageValue));
        }

        if(paint["lerc-clamp-high"]){
            RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(paint["clamp-high-value"] - RenderRaster2.colorscaleEageValue));
            RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(paint["clamp-high-value"]));
        }else{
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-high-value"] - RenderRaster2.colorscaleEageValue));
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-high-value"]));
        }
        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(paint["clamp-high-value"]));
        return [gradient];
    }

    /** rgbaï¼255,255,255,1ï¼è¡¨ç¤ºä¿ç */
    static getIncludeMaskBand (canvas, colorscale, paint: Paint) {
        const ctx = canvas.getContext("2d");
        const calc = RenderRaster2.getCalc(paint);
        const gradients = [];

        for(let include of paint["lerc-include"]){
            if(include[0]<=include[1]){
                const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
                // console.log(`æ°å­è½¬åï¼${include[0]},${include[1]}=>${calc(include[0])*colorscaleLength},${calc(include[1])*colorscaleLength}`);
                RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-low-value"]));
                RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(include[0]));
                RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(include[0]));
                RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(include[1]));
                RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(include[1]));
                RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-high-value"]));
                gradients.push(gradient);
            }
        }

        return gradients;
    }

    /** rgbaï¼255,255,255,1ï¼è¡¨ç¤ºä¸ä¿ç
     * @author James Zhang
     */
    static getExcludeMaskBand (canvas, colorscale, paint: Paint) {
        const ctx = canvas.getContext("2d");
        const calc = RenderRaster2.getCalc(paint);
        const gradients = [];
        for(let include of paint["lerc-exclude"]){
            const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-low-value"]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(include[0]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(include[0]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,1)", calc(include[1]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(include[1]));
            RenderRaster2.renderGradientInterval(gradient, "rgba(0,0,0,0)", calc(paint["clamp-high-value"]));
            gradients.push(gradient);
        }
        return gradients;
    }

    /** 
     * @author yangdonglai
     * 
     * éå¸¸éè¦
     * å½ type æ¯ interval
     * [
     *  [1,"red"],
     *  [2,"green"],
     *  [3,"blue"]
     * ]
     * æ°å­¦ä¸è¡¨ç¤º
     * [-Infinity,2] æ¯ red
     * [2,3) æ¯ green
     * [3,Infinity) æ¯ blue
     * @author James Zhang
     */
    static objectScale2canvas(colorscale,paint: Paint) {
        const canvas = window.document.createElement("canvas");
        canvas.width = colorscaleLength;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        
        const type = colorscale.type;

        

        if (colorscale.stops) {
            const stops = colorscale.stops;
            const min = isNumber(colorscale.min) ? colorscale.min : stops[0][0] || 0;
            const max = isNumber(colorscale.max) ? colorscale.max : stops[stops.length - 1][0] || 1;
            const calc = RenderRaster2.getCalcAligin({
                "clamp-low-value":min - RenderRaster2.colorscaleEageValue,
                "clamp-high-value":max + RenderRaster2.colorscaleEageValue
            });
            if(min !== paint["raster-domain-min"] || max !== paint["raster-domain-max"]){
                console.error(new Error(`[${min}, ${max}] != [${paint["raster-domain-min"]}, ${paint["raster-domain-max"]}] ä¼äº§çæ¸²æéè¯¯`));
            }
            
            // const result = [];
            //æ­¤å¤ä¸ºååéçï¼ç®åæçº¿æ§è¿æ¸¡ï¼ä»¥åå¯ä»¥å¢å åç§éçº¿æ§åå
            if (type === 'interval') {
                
                for(let index = 0;index<colorscale.stops.length; index++){
                    const pos = colorscale.stops[index][0];
                    const color = colorscale.stops[index][1];
                    if(index === 0){
                        const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
                        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,0)", calc(pos));
                        RenderRaster2.renderGradientInterval(gradient, color, calc(pos));
                        // result.push([color, calc(pos)]);
                        RenderRaster2.renderGradientInterval(gradient, color, calc(colorscale.stops[index + 1][0]));
                        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,0)", calc(colorscale.stops[index + 1][0]));
                        // result.push([color, calc(colorscale.stops[index + 1][0])]);
                        ctx.fillStyle = gradient;
                        ctx.fillRect(0, 0, colorscaleLength, 1);
                    }else if (index < colorscale.stops.length - 1) {
                        const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
                        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,0)", calc(pos));
                        RenderRaster2.renderGradientInterval(gradient, color, calc(pos));
                        // result.push([color, calc(pos)]);
                        RenderRaster2.renderGradientInterval(gradient, color, calc(colorscale.stops[index + 1][0]));
                        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,0)", calc(colorscale.stops[index + 1][0]));
                        // result.push([color, calc(colorscale.stops[index + 1][0])]);
                        ctx.fillStyle = gradient;
                        ctx.fillRect(0, 0, colorscaleLength, 1);
                    } else {
                        const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
                        RenderRaster2.renderGradientInterval(gradient, "rgba(255,255,255,0)", calc(pos));
                        RenderRaster2.renderGradientInterval(gradient, color, calc(pos));
                        // result.push([color, calc(pos)]);
                        ctx.fillStyle = gradient;
                        ctx.fillRect(0, 0, colorscaleLength, 1);
                    }
                    
                };
                
            } else {
                const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
                for(let index = 0;index<colorscale.stops.length; index++){
                    const pos = colorscale.stops[index][0];
                    const color = colorscale.stops[index][1];
                    RenderRaster2.renderGradientExponential(gradient, color, calc(pos));
                }
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, colorscaleLength, 1);
            }
            // console.log(JSON.stringify(result));
        } else {
            const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
            const min = isNumber(colorscale.min) ? colorscale.min : colorscale.positions[0] || 0;
            const max = isNumber(colorscale.max) ? colorscale.max : colorscale.positions[colorscale.positions.length - 1] || 1;
            const calc = RenderRaster2.getCalcAligin({
                "clamp-low-value":min - RenderRaster2.colorscaleEageValue,
                "clamp-high-value":max + RenderRaster2.colorscaleEageValue
            });
            if(min !== paint["raster-domain-min"] || max !== paint["raster-domain-max"]){
                console.error(new Error(`[${min}, ${max}] != [${paint["raster-domain-min"]}, ${paint["raster-domain-max"]}] ä¼äº§çæ¸²æéè¯¯`));
            }
            colorscale.positions.forEach((pos, index) => {
                const color = colorscale.colors[index];
                if (index < colorscale.positions.length - 1 && type === 'interval') {
                    RenderRaster2.renderGradientInterval(gradient, color, calc(pos));
                    RenderRaster2.renderGradientInterval(gradient, color, calc(colorscale.positions[index + 1]));
                } else {
                    RenderRaster2.renderGradientExponential(gradient, color, calc(pos));
                }
            });
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, colorscaleLength, 1);
        }
        
        return canvas;
    }
    static typedArray2canvas(colorscale) {
        const canvas = window.document.createElement("canvas");
        canvas.width = colorscaleLength;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        const imgData = ctx.createImageData(colorscaleLength, 1);
        imgData.data.set(colorscale);
        ctx.putImageData(imgData, 0, 0);
        return canvas;
    }

    static canvas2texture(context, canvas) {
        if (!context) return;
        const gl = context.gl;
        // ä¸ºäºä¸å½±åä¹åçæµç¨çåæ°
        const preValue = context.pixelStoreUnpackPremultiplyAlpha.get();
        context.pixelStoreUnpackPremultiplyAlpha.set(true);
        const textureScale = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, textureScale);
        // Set the parameters so we can render any size image.
        // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        // Upload the image into the texture.
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
        context.pixelStoreUnpackPremultiplyAlpha.set(preValue);
        return textureScale;
    }
    static getTexture(paint:Paint) {
        const name = paint["raster-colorscale"];

        if (!paint["raster-colorscale"]) {
            return null;
        }
        if (!RenderRaster2.context) {
            console.error(`RenderRaster need bind context`);
        }

        
        if (typeof name === 'string' && RenderRaster2.colorscales[name]) {
            if (RenderRaster2.cache.has(name)) {
                return RenderRaster2.cache.get(name);
            }
            RenderRaster2.cache.set(name, RenderRaster2.colorscale2Texture(RenderRaster2.context, RenderRaster2.colorscales[name], paint));
            return RenderRaster2.cache.get(name);
        }else{
            // ä¸ºäºåæ·±åº¦å¯¹æ¯
            let jsonName = JSON.stringify(paint);
            if (RenderRaster2.cache.has(jsonName)) {
                return RenderRaster2.cache.get(jsonName);
            }
            RenderRaster2.cache.set(jsonName, RenderRaster2.colorscale2Texture(RenderRaster2.context, name, paint));
            return RenderRaster2.cache.get(jsonName);
        }
        
    }
    static addColorScale(name, colorscale, render = false) {
        RenderRaster2.colorscales[name] = colorscale;
        if (render) {
            return RenderRaster2.getTexture(name);
        } else {
            return RenderRaster2.colorscales[name];
        }
    }
}
// RenderRaster.cache = {};
RenderRaster2.cache = new SmartMap();

RenderRaster2.colorscales = initColorscales;

RenderRaster2.textureLength = colorscaleLength;
/** éè²è¡¨è¾¹ç¼é¢è² */

RenderRaster2.colorscaleEageValue = 10;
export default RenderRaster2;
